import React from "react";
import {
    Button,
    CardBody, CardHeader,
    Col,
    Container,
    FormInput,
    InputGroup,
    Row
} from "shards-react";
import {connect} from "react-redux";
import {requestPharmacy, updatePharmacy} from "../../actions/pharmacies.action";
import PageTitle from "../../components/common/PageTitle";
import {requestProviders} from "../../actions/providers.action";

class Pharmacy extends React.Component {
    constructor(props) {
        super(props);
        let id = this.props.match.params.id;
        this.props.loadData(id);
        this.props.loadProviders();
        this.state = {
            provider: '',
            siret: '',
            telephone: '',
            rs: '',
            providers: null
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            provider: this.props.pharmacies.data.provider_id,
            siret: this.props.pharmacies.data.siret,
            telephone: this.props.pharmacies.data.telephone,
            rs: this.props.pharmacies.data.rs
        })
    }

    handleChange(event) {
        let name = event.target.name;
        this.setState({ [name] : event.target.value});
    }
    updateDetails = () => {
        let payload = {
            id: this.props.pharmacies.data.no_finess_et,
            provider: this.state.provider,
            siret: this.state.siret,
            telephone: this.state.telephone,
            rs: this.state.rs
        };
        this.props.updatePharmacy(payload);
    }
    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                        {
                            this.props.pharmacies.fetching ? (
                                <div className="flex-center">
                                    <div className="text-center d-block">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <Row noGutters className="page-header pt-4">
                                        <PageTitle
                                            title={this.props.pharmacies.data.rs}
                                            subtitle="Pharmacie" className="text-sm-left mb-3"/>
                                    </Row>
                                    <Row>
                                        <Col lg="12" className="mx-auto mt-4">
                                            {
                                                this.props.providers.fetching ? (
                                                    <div className="flex-center">
                                                        <div className="text-center d-block">
                                                            <div className="spinner-border" role="status">
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <strong>Les providers :</strong>
                                                        {
                                                          this.props.providers.data.map((provider, index) => {
                                                            return (
                                                                <div key={index}>
                                                                    <div>
                                                                        {provider.name} : {provider.id}
                                                                    </div>
                                                                </div>
                                                            );
                                                          })
                                                        }
                                                    </div>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" className="mx-auto mt-4">
                                            <Row>
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="provider">Provider</label>
                                                    <InputGroup seamless>
                                                        <FormInput
                                                            name="provider"
                                                            defaultValue={this.props.pharmacies.data.provider ? this.props.pharmacies.data.provider.id : null}
                                                            onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="siret">Siret</label>
                                                    <InputGroup seamless>
                                                        <FormInput
                                                            name="siret"
                                                            defaultValue={this.props.pharmacies.data.siret}
                                                            onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg="12" className="mx-auto mt-4">
                                            <Row>
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="rs">Raison sociale</label>
                                                    <InputGroup seamless>
                                                        <FormInput
                                                            name="rs"
                                                            defaultValue={this.props.pharmacies.data.rs}
                                                            onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="telephone">Téléphone</label>
                                                    <InputGroup seamless>
                                                        <FormInput
                                                            name="telephone"
                                                            defaultValue={this.props.pharmacies.data.telephone}
                                                            onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md="12" className="form-group">
                                            <Row className="mt-5">
                                                <Col md="6">
                                                    <Button
                                                        onClick={() => this.updateDetails()}>
                                                        Enregistrer
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </Container>
        )
    };
}

function mapStateToProps(state) {
    return {
        pharmacies: state['pharmacies'],
        providers: state['providers'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (e) => dispatch(requestPharmacy(e)),
    loadProviders: (e) => dispatch(requestProviders(e)),
    updatePharmacy: (e) => dispatch(updatePharmacy(e))
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pharmacy);


// WEBPACK FOOTER //
// ./src/views/Pharmacies/Pharmacy.js